import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAppointmentsQueryVariables = Types.Exact<{
  from: Types.Scalars["Date"]["input"];
  to: Types.Scalars["Date"]["input"];
  timeZone: Types.Scalars["String"]["input"];
}>;

export type GetAppointmentsQuery = {
  __typename?: "Query";
  getAppointmentSchedules: Array<{
    __typename?: "AppointmentSchedule";
    uuid: string;
    startTime: string;
    endTime: string;
    description: string | null;
    eventStatus: Types.ScheduleStatus;
    isLateCancel: boolean | null;
    unpaidReason: string | null;
    appointmentType: {
      __typename?: "AppointmentType";
      uuid: string;
      name: string;
      color: string;
    };
    appointmentCredit: {
      __typename?: "AppointmentCredit";
      uuid: string;
    } | null;
    user: {
      __typename?: "User";
      uuid: string;
      firstName: string;
      lastName: string;
      primaryImage: string | null;
    };
    staff: {
      __typename?: "User";
      uuid: string;
      firstName: string;
      lastName: string;
      primaryImage: string | null;
    } | null;
  }>;
};

export type AppointmentFragment = {
  __typename?: "AppointmentSchedule";
  uuid: string;
  startTime: string;
  endTime: string;
  description: string | null;
  eventStatus: Types.ScheduleStatus;
  isLateCancel: boolean | null;
  unpaidReason: string | null;
  appointmentType: {
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    color: string;
  };
  appointmentCredit: { __typename?: "AppointmentCredit"; uuid: string } | null;
  user: {
    __typename?: "User";
    uuid: string;
    firstName: string;
    lastName: string;
    primaryImage: string | null;
  };
  staff: {
    __typename?: "User";
    uuid: string;
    firstName: string;
    lastName: string;
    primaryImage: string | null;
  } | null;
};

export type GetStaffForAppointmentsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetStaffForAppointmentsQuery = {
  __typename?: "Query";
  getStaff: Array<{
    __typename?: "Staff";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
    primaryImage: string | null;
    appointmentTypes: Array<{
      __typename?: "AppointmentType";
      uuid: string;
    } | null>;
  } | null>;
};

export type StaffFragment = {
  __typename?: "Staff";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
  primaryImage: string | null;
  appointmentTypes: Array<{
    __typename?: "AppointmentType";
    uuid: string;
  } | null>;
};

export type GetStaffBusyTimesQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetStaffInput>;
  busyTimesFilter: Types.TimeRangeFilter;
}>;

export type GetStaffBusyTimesQuery = {
  __typename?: "Query";
  getStaff: Array<{
    __typename?: "Staff";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
    primaryImage: string | null;
    busyTimes: Array<{
      __typename?: "BusyTime";
      startTime: string;
      endTime: string;
    }> | null;
  } | null>;
};

export type StaffBusyTimesFragment = {
  __typename?: "Staff";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
  primaryImage: string | null;
  busyTimes: Array<{
    __typename?: "BusyTime";
    startTime: string;
    endTime: string;
  }> | null;
};

export type GetAppointmentTypesForAppointmentsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAppointmentTypesForAppointmentsQuery = {
  __typename?: "Query";
  getAppointmentTypes: Array<{
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    color: string;
    staff: Array<{ __typename?: "Staff"; userUuid: string } | null>;
  }>;
};

export type AppointmentTypeFragment = {
  __typename?: "AppointmentType";
  uuid: string;
  name: string;
  color: string;
  staff: Array<{ __typename?: "Staff"; userUuid: string } | null>;
};

export type GetStaffWorkingHoursQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetStaffInput>;
}>;

export type GetStaffWorkingHoursQuery = {
  __typename?: "Query";
  getStaff: Array<{
    __typename?: "Staff";
    userUuid: string;
    workingHours: Array<{
      __typename?: "WorkingHour";
      dayOfTheWeek: Types.DayOfTheWeek;
      startTime: string;
      endTime: string;
    }>;
  } | null>;
};

export type StaffWorkingHoursFragment = {
  __typename?: "Staff";
  userUuid: string;
  workingHours: Array<{
    __typename?: "WorkingHour";
    dayOfTheWeek: Types.DayOfTheWeek;
    startTime: string;
    endTime: string;
  }>;
};

export type WorkingHoursReminderMutationVariables = Types.Exact<{
  userUuid: Types.Scalars["String"]["input"];
}>;

export type WorkingHoursReminderMutation = {
  __typename?: "Mutation";
  workingHoursReminder: { __typename?: "SuccessResponse"; success: boolean };
};

export const AppointmentFragmentDoc = gql`
  fragment Appointment on AppointmentSchedule {
    uuid
    startTime
    endTime
    description
    eventStatus
    isLateCancel
    unpaidReason
    appointmentType {
      uuid
      name
      color
    }
    appointmentCredit {
      uuid
    }
    user {
      uuid
      firstName
      lastName
      primaryImage
    }
    staff {
      uuid
      firstName
      lastName
      primaryImage
    }
  }
`;
export const StaffFragmentDoc = gql`
  fragment Staff on Staff {
    userUuid
    firstName
    lastName
    primaryImage
    appointmentTypes {
      uuid
    }
  }
`;
export const StaffBusyTimesFragmentDoc = gql`
  fragment StaffBusyTimes on Staff {
    userUuid
    firstName
    lastName
    primaryImage
    busyTimes(filter: $busyTimesFilter) {
      startTime
      endTime
    }
  }
`;
export const AppointmentTypeFragmentDoc = gql`
  fragment AppointmentType on AppointmentType {
    uuid
    name
    color
    staff {
      userUuid
    }
  }
`;
export const StaffWorkingHoursFragmentDoc = gql`
  fragment StaffWorkingHours on Staff {
    userUuid
    workingHours {
      dayOfTheWeek
      startTime
      endTime
    }
  }
`;
export const GetAppointmentsDocument = gql`
  query GetAppointments($from: Date!, $to: Date!, $timeZone: String!) {
    getAppointmentSchedules(from: $from, to: $to, timeZone: $timeZone) {
      ...Appointment
    }
  }
  ${AppointmentFragmentDoc}
`;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGetAppointmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAppointmentsQuery,
    GetAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(
    GetAppointmentsDocument,
    options,
  );
}
export function useGetAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentsQuery,
    GetAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentsQuery,
    GetAppointmentsQueryVariables
  >(GetAppointmentsDocument, options);
}
export type GetAppointmentsQueryHookResult = ReturnType<
  typeof useGetAppointmentsQuery
>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentsLazyQuery
>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<
  GetAppointmentsQuery,
  GetAppointmentsQueryVariables
>;
export const GetStaffForAppointmentsDocument = gql`
  query GetStaffForAppointments {
    getStaff {
      ...Staff
    }
  }
  ${StaffFragmentDoc}
`;

/**
 * __useGetStaffForAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetStaffForAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffForAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffForAppointmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaffForAppointmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStaffForAppointmentsQuery,
    GetStaffForAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStaffForAppointmentsQuery,
    GetStaffForAppointmentsQueryVariables
  >(GetStaffForAppointmentsDocument, options);
}
export function useGetStaffForAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStaffForAppointmentsQuery,
    GetStaffForAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStaffForAppointmentsQuery,
    GetStaffForAppointmentsQueryVariables
  >(GetStaffForAppointmentsDocument, options);
}
export type GetStaffForAppointmentsQueryHookResult = ReturnType<
  typeof useGetStaffForAppointmentsQuery
>;
export type GetStaffForAppointmentsLazyQueryHookResult = ReturnType<
  typeof useGetStaffForAppointmentsLazyQuery
>;
export type GetStaffForAppointmentsQueryResult = Apollo.QueryResult<
  GetStaffForAppointmentsQuery,
  GetStaffForAppointmentsQueryVariables
>;
export const GetStaffBusyTimesDocument = gql`
  query GetStaffBusyTimes(
    $input: GetStaffInput
    $busyTimesFilter: TimeRangeFilter!
  ) {
    getStaff(getStaffInput: $input) {
      ...StaffBusyTimes
    }
  }
  ${StaffBusyTimesFragmentDoc}
`;

/**
 * __useGetStaffBusyTimesQuery__
 *
 * To run a query within a React component, call `useGetStaffBusyTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffBusyTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffBusyTimesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      busyTimesFilter: // value for 'busyTimesFilter'
 *   },
 * });
 */
export function useGetStaffBusyTimesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStaffBusyTimesQuery,
    GetStaffBusyTimesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStaffBusyTimesQuery,
    GetStaffBusyTimesQueryVariables
  >(GetStaffBusyTimesDocument, options);
}
export function useGetStaffBusyTimesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStaffBusyTimesQuery,
    GetStaffBusyTimesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStaffBusyTimesQuery,
    GetStaffBusyTimesQueryVariables
  >(GetStaffBusyTimesDocument, options);
}
export type GetStaffBusyTimesQueryHookResult = ReturnType<
  typeof useGetStaffBusyTimesQuery
>;
export type GetStaffBusyTimesLazyQueryHookResult = ReturnType<
  typeof useGetStaffBusyTimesLazyQuery
>;
export type GetStaffBusyTimesQueryResult = Apollo.QueryResult<
  GetStaffBusyTimesQuery,
  GetStaffBusyTimesQueryVariables
>;
export const GetAppointmentTypesForAppointmentsDocument = gql`
  query GetAppointmentTypesForAppointments {
    getAppointmentTypes {
      ...AppointmentType
    }
  }
  ${AppointmentTypeFragmentDoc}
`;

/**
 * __useGetAppointmentTypesForAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTypesForAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTypesForAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTypesForAppointmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentTypesForAppointmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAppointmentTypesForAppointmentsQuery,
    GetAppointmentTypesForAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppointmentTypesForAppointmentsQuery,
    GetAppointmentTypesForAppointmentsQueryVariables
  >(GetAppointmentTypesForAppointmentsDocument, options);
}
export function useGetAppointmentTypesForAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentTypesForAppointmentsQuery,
    GetAppointmentTypesForAppointmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentTypesForAppointmentsQuery,
    GetAppointmentTypesForAppointmentsQueryVariables
  >(GetAppointmentTypesForAppointmentsDocument, options);
}
export type GetAppointmentTypesForAppointmentsQueryHookResult = ReturnType<
  typeof useGetAppointmentTypesForAppointmentsQuery
>;
export type GetAppointmentTypesForAppointmentsLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentTypesForAppointmentsLazyQuery
>;
export type GetAppointmentTypesForAppointmentsQueryResult = Apollo.QueryResult<
  GetAppointmentTypesForAppointmentsQuery,
  GetAppointmentTypesForAppointmentsQueryVariables
>;
export const GetStaffWorkingHoursDocument = gql`
  query GetStaffWorkingHours($input: GetStaffInput) {
    getStaff(getStaffInput: $input) {
      ...StaffWorkingHours
    }
  }
  ${StaffWorkingHoursFragmentDoc}
`;

/**
 * __useGetStaffWorkingHoursQuery__
 *
 * To run a query within a React component, call `useGetStaffWorkingHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffWorkingHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffWorkingHoursQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStaffWorkingHoursQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStaffWorkingHoursQuery,
    GetStaffWorkingHoursQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStaffWorkingHoursQuery,
    GetStaffWorkingHoursQueryVariables
  >(GetStaffWorkingHoursDocument, options);
}
export function useGetStaffWorkingHoursLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStaffWorkingHoursQuery,
    GetStaffWorkingHoursQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStaffWorkingHoursQuery,
    GetStaffWorkingHoursQueryVariables
  >(GetStaffWorkingHoursDocument, options);
}
export type GetStaffWorkingHoursQueryHookResult = ReturnType<
  typeof useGetStaffWorkingHoursQuery
>;
export type GetStaffWorkingHoursLazyQueryHookResult = ReturnType<
  typeof useGetStaffWorkingHoursLazyQuery
>;
export type GetStaffWorkingHoursQueryResult = Apollo.QueryResult<
  GetStaffWorkingHoursQuery,
  GetStaffWorkingHoursQueryVariables
>;
export const WorkingHoursReminderDocument = gql`
  mutation WorkingHoursReminder($userUuid: String!) {
    workingHoursReminder(input: { userUuid: $userUuid }) {
      success
    }
  }
`;
export type WorkingHoursReminderMutationFn = Apollo.MutationFunction<
  WorkingHoursReminderMutation,
  WorkingHoursReminderMutationVariables
>;

/**
 * __useWorkingHoursReminderMutation__
 *
 * To run a mutation, you first call `useWorkingHoursReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkingHoursReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workingHoursReminderMutation, { data, loading, error }] = useWorkingHoursReminderMutation({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useWorkingHoursReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WorkingHoursReminderMutation,
    WorkingHoursReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WorkingHoursReminderMutation,
    WorkingHoursReminderMutationVariables
  >(WorkingHoursReminderDocument, options);
}
export type WorkingHoursReminderMutationHookResult = ReturnType<
  typeof useWorkingHoursReminderMutation
>;
export type WorkingHoursReminderMutationResult =
  Apollo.MutationResult<WorkingHoursReminderMutation>;
export type WorkingHoursReminderMutationOptions = Apollo.BaseMutationOptions<
  WorkingHoursReminderMutation,
  WorkingHoursReminderMutationVariables
>;
